import React, { useState, useEffect, useRef } from 'react'
import {useParams, useSearchParams} from 'react-router-dom';
import './searchObject.scss'
import AIPanel from "../../../components/AIChat/AIPanel";
import { useConvokeDomainContext } from '../ConvokeDomainProvider';
import {TableControl} from 'spark-core-dx/components';
import {useCoreRoute} from 'spark-core-dx/hooks'

const SearchEntityObject = ({ }) => {

    const [data, setData] = useState(null);
    const [fieldOverrides, setFieldOverrides] = useState(null);
    const {coreNavigate} = useCoreRoute();
    const {entityObjectMgr, loadingState } = useConvokeDomainContext();
    const {eoId} = useParams();
     const [searchParams] = useSearchParams();
    const wId = searchParams.get('wId');
    const wdId = searchParams.get('wdId');
    const [initialSearch,setInitialSearch] = useState(false);
    const pageRef = useRef(null);
       

    useEffect(() => {
        if (!data && entityObjectMgr?.uiMetadata && !initialSearch) {
            setInitialSearch(true);
            const metadata = entityObjectMgr?.uiMetadata?.length == undefined ? entityObjectMgr?.uiMetadata : entityObjectMgr?.uiMetadata?.first();
            let take = metadata?.ProfilePreferences?.HasPaging ? metadata?.ProfilePreferences?.HasPaging.first() : metadata?.HasPaging ? metadata?.HasPaging.first() : 50000;
            const isServerSide = metadata?.ProfilePreferences?.ServerFilterSort !== undefined && metadata?.ProfilePreferences?.ServerFilterSort !== null   ? 
                                 metadata?.ProfilePreferences?.ServerFilterSort : metadata?.ServerFilterSort;
                if(isServerSide === false)
                    entityObjectMgr?.search({id:eoId,queryParams:{wId,wdId,search:true},forceUpdate:true,take: (isServerSide ? take : 50000) })
        }
        else if(entityObjectMgr && !entityObjectMgr?.uiMetadata) {
            entityObjectMgr.LoadMetadata();
        }
    },[entityObjectMgr?.uiMetadata])

    useEffect(() => {
        
        if (!loadingState && entityObjectMgr) {
            
            setData(entityObjectMgr?.filteredData)
        }
    }, [loadingState, entityObjectMgr?.filteredData])

    
    const onServerSideQuery = async (itemQuery) => {
        if(entityObjectMgr?.filteredData)
            await entityObjectMgr.search({id:eoId,queryParams:{wId,wdId,search:true}, searchModel: itemQuery, forceUpdate: true })
    }

    const onUpdatePanel = async (UICommand, item, value)=>{
        if(UICommand === "filter"){
              const selectColumns = item?.SelectColumns
              const deepCopy = v => typeof structuredClone === "function" ? structuredClone(v) : JSON.parse(JSON.stringify(v)); // fallback
                if (selectColumns && selectColumns.length > 0 && entityObjectMgr?.uiMetadata && entityObjectMgr?.uiMetadata?.length>0) {
                    const allowed = new Set(selectColumns.map(s => s.toLowerCase()));
                    let fieldToOverride = entityObjectMgr?.uiMetadata.first().Fields.map(deepCopy);
                    // Flip ShowOnGrid on the copies only
                    fieldToOverride = fieldToOverride.map(f => {
                        const name = (f?.FieldName ?? "").toString().toLowerCase();
                        if (!allowed.has(name)) {
                            f.ShowOnGrid = false;
                            f.IsActive = false;
                            f.IsDeleted = true;
                        }
                        return f;
                    });

                    setFieldOverrides(fieldToOverride);
                }

            await entityObjectMgr.search({id:item.EntityObjectId, searchModel: item,queryParams:{wid:value["warehouseId"],wdid:value["warehouseDeploymentId"],search:true}, forceUpdate: true })   
        }
    }


    return ( <>
                    {entityObjectMgr?.uiMetadata?.AISupportsSession || true ?
            		<AIPanel
						childrenRef={pageRef}
						open={true}
						onUpdatePanel={onUpdatePanel}
						mapToClass={'core-layout'}
                        params={{wdId,wId}}
						referenceId={eoId}
						referenceName={"object"}
                        operationName = {"AIQuestionEntityObject"}
						onCancel={()=>{coreNavigate("/dynamic/entityobject/")}}
                        >
               <div className="ai-panel__table">
                            <TableControl
                                data={data}
                                className={"search-object-table"}
                                enableMultiSelect={false}
                                defaultNumRows={50}
                                onServerSideQuery={onServerSideQuery}
                                metadata={entityObjectMgr?.uiMetadata}
                                loadingState={loadingState}
                                filters={entityObjectMgr?.filters}
                                mgr={entityObjectMgr}
                                fieldOverrides = {fieldOverrides}
                                enableSidePanelEdit={true}
                            />
                            </div>
					</AIPanel> :
                     <TableControl
                                data={data}
                                className={"search-object-table"}
                                enableMultiSelect={false}
                                fieldOverrides = {fieldOverrides}
                                defaultNumRows={50}
                                onServerSideQuery={onServerSideQuery}
                                metadata={entityObjectMgr?.uiMetadata}
                                loadingState={loadingState}
                                filters={entityObjectMgr?.filters}
                                mgr={entityObjectMgr}
                                enableSidePanelEdit={true}
                            />}
           
        </>
    );
}

export default SearchEntityObject;



